export default "__VITE_ASSET__BTpPZZxc__"